// eslint-disable-next-line no-restricted-imports -- Intended
import {isNil, path, split} from 'ramda';

import {Nullish} from 'shared/web';

import {DefaultFoundationTheme, ThemeColorPath} from './foundationTheme';

export function getColorByPath(
  color: ThemeColorPath | Nullish,
  theme: DefaultFoundationTheme
): string | undefined {
  if (isNil(color)) {
    return undefined;
  }
  return path(split('.', color), theme.colors);
}
